// SABERA: 度数入力ステッパー (snippets/sabera-lens-value-stepper.liquid)。
// 上下ボタンで step 刻みに増減、表示は小数2桁に揃える。
document.querySelectorAll('[data-sabera-stepper]').forEach((stepper) => {
  const input = stepper.querySelector('[data-sabera-stepper-input]');
  const upBtn = stepper.querySelector('[data-sabera-stepper-up]');
  const downBtn = stepper.querySelector('[data-sabera-stepper-down]');
  if (!input) return;

  const step = parseFloat(input.step) || 1;
  const min = input.min !== '' ? parseFloat(input.min) : -Infinity;
  const max = input.max !== '' ? parseFloat(input.max) : Infinity;

  const format = (num) => {
    if (!Number.isFinite(num)) return '-0.00';
    return num === 0 ? '-0.00' : num.toFixed(2);
  };

  const clamp = (num) => Math.min(max, Math.max(min, num));

  const currentValue = () => {
    const num = parseFloat(input.value);
    return Number.isFinite(num) ? num : 0;
  };

  // min/max に達した方向のボタンは押せなくする
  const syncArrows = () => {
    const num = currentValue();
    if (upBtn) upBtn.disabled = num >= max;
    if (downBtn) downBtn.disabled = num <= min;
  };

  const setValue = (num) => {
    input.value = format(clamp(num));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    syncArrows();
  };

  upBtn?.addEventListener('click', () => setValue(currentValue() + step));
  downBtn?.addEventListener('click', () => setValue(currentValue() - step));
  input.addEventListener('input', syncArrows);
  input.addEventListener('blur', () => {
    if (input.value === '') return;
    setValue(currentValue());
  });

  // 初期表示も小数2桁に揃える
  if (input.value !== '') input.value = format(currentValue());
  syncArrows();
});
